import React, { useEffect, useState } from "react";
import { AccessLevel, MenuLink } from "../types/types";
import {
  useLocation,
  useNavigate,
} from "react-router-dom";
import PlatformTableComponent from "../components/platformTableComponent/platformTableComponent";
import { Tabs } from "antd";
import getcustomDetailsPageMap from "./customDetailPageMapping";
import getCustomLandingPageMap from "./CustomLandingPageMapping";
import { extraActionsOnRecordCallbackMap } from "./customDetailPageMapping";
import { allowedActionsForRenderingCustomDetailPageMap } from "./customDetailPageMapping";
import { handleRowLevelActionCallbackMap } from "./customDetailPageMapping";
import { handleTopLevelActionCallbackMap } from "./customDetailPageMapping";
import { WebViewUserAgent } from "../utils/ApiConstants";
import { Trans, useTranslation } from 'react-i18next'
interface Props {
  subMenu: MenuLink
}

const CommonLandingPage: React.FC<Props> = ({ subMenu }) => {

  const { t } = useTranslation();
  const navigate = useNavigate();
  const { state } = useLocation();

  const userAgent = navigator.userAgent || "";

  const onChange = (path: string) => {
    navigate("/" + path, { state: state });
  };

  const customLandingPageMap = getCustomLandingPageMap();

  const itemList: any = subMenu?.subMenuList.map((item) => {

    if (customLandingPageMap.has(item.subMenuCode)) {
      return {
        label: <span className="font-medium">{t(item.subMenuName)}</span>,
        key: item.url,
        children: customLandingPageMap.get(item.subMenuCode)
      }
    }

    //In Webview if viewView flag for submenu is false - do not create that submenu
    if (userAgent.includes(WebViewUserAgent)) {
      if (item.hasOwnProperty("webView") && item.webView === false) {
        return undefined;
      }
    }

    return {
      label: <span className="font-medium">{t(item.subMenuName)}</span>,
      key: item.url,
      children: <PlatformTableContainer
        moduleAccessLevel={item.accessLevel}
        bluePrintApi={item.dataTableBluePrintUrl as string}
        searchApi={item.searchBluePrintUrl as string}
        title={t(item.subMenuName)}
        moduleCode={item.moduleCode!}
      ></PlatformTableContainer>
    };

  }).filter(item => item !== undefined);

  const location = useLocation();


  const [activeKey, setActiveKey] = useState<string>();

  useEffect(() => {
    const tempKey = location.pathname.substring(1);
    // Only set active key if it matches a submenu URL
    // setActiveKey(undefined);
    if (tempKey && subMenu?.subMenuList.some(item => item.url === tempKey)) {
      setActiveKey(tempKey);
    } else {
      setActiveKey(subMenu.subMenuList[0].url);
    }

  }, [location]);

  return (

    <Tabs
      activeKey={activeKey ? activeKey : undefined}
      type="card"
      popupClassName="bg-white"
      destroyInactiveTabPane={true}
      onChange={(path) => {
        onChange(path);
      }}
      items={itemList}
      className="mt-1 ml-1 mt-md-2 ml-md-1 mr-3 common-landing-page"
    />

  );
};

export default CommonLandingPage;

interface LocalProps {
  title: string;
  moduleCode: string;
  moduleAccessLevel?: AccessLevel;
  bluePrintApi: string;
  searchApi: string;
}

const PlatformTableContainer: React.FC<LocalProps> = ({ title, moduleAccessLevel, moduleCode, bluePrintApi, searchApi }) => {


  const customDetailsPageMap = getcustomDetailsPageMap();
  const { t } = useTranslation();
  return (
    <Trans t={t}>


      <PlatformTableComponent
        bluePrintApi={bluePrintApi}
        searchApi={searchApi}
        title={t(title!)}
        moduleCode={moduleCode}
        moduleAccessLevel={moduleAccessLevel}
        renderCustomDetailPage={customDetailsPageMap.get(moduleCode)}
        extraActionsOnRecordCallback={extraActionsOnRecordCallbackMap.get(moduleCode)}
        allowedActionsForRenderingCustomDetailPage={allowedActionsForRenderingCustomDetailPageMap.get(moduleCode)}
        handleRowLevelActionCallback={handleRowLevelActionCallbackMap.get(moduleCode)}
        handleTopLevelActionCallback={handleTopLevelActionCallbackMap.get(moduleCode)}
      />
    </Trans>
  );
};




